import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { MaterialModule } from 'src/app/app-material.module';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-ricerca-profili-competenze',
  templateUrl: './ricerca-profili-competenze.component.html',
  styleUrls: ['./ricerca-profili-competenze.component.scss'],
})
export class RicercaProfiliCompetenzeComponent  {

}

import { CommonModule } from '@angular/common';
import { CommonsService } from 'src/app/services/commons/commons.service';

@Component({
  selector: 'detail-profili',
  templateUrl: './detail-dialogs/detail-profili.html',
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class DetailProfiliDialog implements OnInit {
  displayedColumns: string[] = ['competenza', 'eqf', 'azioni'];
  dataSource = new MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;



  title: string;
  datiProfilo: any;
  classificazioniAda: any;
  classificazioniIstat: any;
  classificazioniAteco: any;
  classificazioniIsco: any;
  competenze: any;
  paginatorSize: any;
  constructor(
    public dialogRef: MatDialogRef<DetailProfiliDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private commons: CommonsService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;

    this.commons.getProfiloDettaglio(this.data.id).subscribe({
      next: (response: any) => {
        this.datiProfilo = response.result;
      }
    })

    this.commons.getCodiciAdaByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAda = response.result;
      }
    })

    this.commons.getCodiciIstatByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIstat = response.result;
      }
    })

    this.commons.getCodiciAtecoByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAteco = response.result;
      }
    })

    this.commons.getCodiciIscoByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIsco = response.result;
      }
    })

    this.commons.getCompetenzeByIdProposta(this.data.id).subscribe({
      next: (response: any) => {
        this.competenze = response.result;
        this.paginatorSize = response.result.count;
        this.dataSource = this.competenze;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  openDettaglioCompetenza(el: any) {
    const dialogRef = this.dialog.open(DetailAbilitaConoscenzeDialog, {
      data: { title: "Lista abilità e conoscenze", id: el.id },
      height: '95%',
      width: '100%'
    });


    dialogRef.afterClosed().subscribe((result: any) => {

    })
  }

}

@Component({
  selector: 'detail-abilita-conoscenze',
  templateUrl: './detail-dialogs/detail-abilita-conoscenze.html',
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class DetailAbilitaConoscenzeDialog implements OnInit {
  displayedColumns: string[] = ['competenza', 'eqf', 'azioni'];
  dataSource = new MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;



  title: string;
  abilita: any;
  conoscenze: any;
  constructor(
    public dialogRef: MatDialogRef<DetailAbilitaConoscenzeDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commons: CommonsService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;
    this.commons.getAbilitaByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.abilita = response.result;
      }
    })

    this.commons.getConoscenzeByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.conoscenze = response.result;
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

//POPUP DETTAGLIO COMPETENZA
@Component({
  selector: 'detail-compenteza',
  templateUrl: './detail-dialogs/detail-competenze.html',
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class DetailCompetenzaDialog implements OnInit {
  displayedColumns: string[] = ['nomeProfilo', 'descrizioneArea.descrizione'];
  dataSource = new MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  title: string;
  datiCompetenza : any;
  classificazioniAda: any;
  classificazioniIstat: any;
  classificazioniAteco: any;
  classificazioniIsco: any;
  elencoProfili: any;
  paginatorSize: any;
  listaAbilita: any;
  listaConoscenze: any;
  constructor(
    public dialogRef: MatDialogRef<DetailProfiliDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private commons: CommonsService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;

    this.commons.getCompetenzaDettaglio(this.data.id).subscribe({
      next: (response: any) => {
        this.datiCompetenza = response.result;
      }
    })

    this.commons.getCodiciAdaByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAda = response.result;
      }
    })

    this.commons.getCodiciIstatByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIstat = response.result;
      }
    })

    this.commons.getCodiciAtecoByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAteco = response.result;
      }
    })

    this.commons.getCodiciIscoByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIsco = response.result;
      }
    })

    this.commons.getAbilitaByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.listaAbilita = response.result;
      }
    })

    this.commons.getConoscenzeByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.listaConoscenze = response.result;
      }
    })

    this.commons.getProfiliProfessionaliByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.elencoProfili = response.result;
        this.paginatorSize = response.result.count;
        this.dataSource = this.elencoProfili;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
